module.exports = __webpack_public_path__ + "static/media/Anaheim_Ducks.825b23e8.svg";